import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import Button from 'new/components/Button/Button';
import Modal from 'new/components/Modal';

type Props = {
  open: boolean;
  description: string;
  onClose: () => void;
  onConfirm: () => void;
};

const StyledModal = styled(Modal)(({ theme }) => ({
  '.MuiPaper-root': {
    width: 480,

    '> .MuiTypography-root': {
      marginBottom: theme.spacing(3),
      textAlign: 'center',
      fontSize: '1.75rem',

      '&.description': {
        fontSize: '1rem',
      },
    },
  },

  button: {
    margin: theme.spacing(0, 1),
  },
}));

const ConfirmSuperAdminModal: React.FC<Props> = ({
  open,
  description,
  onClose,
  onConfirm,
}) => (
  <StyledModal title="Are you sure?" open={open} onClose={onClose}>
    <Typography className="description">{description}</Typography>
    <Box width="100%" display="flex" justifyContent="center" mt={6}>
      <Button color="secondary" variant="outlined" onClick={onClose}>
        cancel
      </Button>
      <Button onClick={onConfirm}>yes</Button>
    </Box>
  </StyledModal>
);

export default ConfirmSuperAdminModal;
